import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem,
} from '@chegg-wt/core/utils/localStorage'
import {
  getSessionStorageItem,
  setSessionStorageItem,
  removeSessionStorageItem,
} from '@chegg-wt/core/utils/sessionStorage'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

export const modalSeenKey = 'modalSeen'

export enum StorageType {
  sessionStorage = 'sessionStorage',
  localStorage = 'localStorage',
}

export const modalSeen = (storage: StorageType) => {
  let setStorageItem
  let getStorageItem
  let removeStorageItem

  if (storage === StorageType.localStorage) {
    setStorageItem = setLocalStorageItem
    getStorageItem = getLocalStorageItem
    removeStorageItem = removeLocalStorageItem
  } else {
    setStorageItem = setSessionStorageItem
    getStorageItem = getSessionStorageItem
    removeStorageItem = removeSessionStorageItem
  }

  return {
    set: (modalName: string): void => {
      try {
        const localSeenValue = JSON.parse(getStorageItem(modalSeenKey)) || {}
        localSeenValue[modalName] = true

        setStorageItem(modalSeenKey, JSON.stringify(localSeenValue))
      } catch (e) {
        setStorageItem(modalSeenKey, JSON.stringify({ [modalName]: true }))
        trackWithoutThrow(e)
      }
    },
    get: (modalName: string): boolean => {
      try {
        const localSeenValue = JSON.parse(getStorageItem(modalSeenKey)) || {}
        return !!localSeenValue[modalName]
      } catch (e) {
        trackWithoutThrow(e)
        return false
      }
    },
    clear: (modalName?: string): void => {
      if (!modalName) removeStorageItem(modalSeenKey)

      try {
        const localSeenValue = JSON.parse(getStorageItem(modalSeenKey)) || {}
        delete localSeenValue[modalName]
        setSessionStorageItem(modalSeenKey, JSON.stringify(localSeenValue))
      } catch (e) {
        removeStorageItem(modalSeenKey)
        trackWithoutThrow(e)
      }
    },
  }
}
